// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__DAieH","colMaxWidth":"Table_colMaxWidth__27jxw"};